module.exports = __webpack_public_path__ + "media/images/ui__textArrowUpAccent--dark-ab2e280268b8c4a48c3966a7ad0190b9.png";